import './YesNoButton.scss';
import { Form, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { FiAlertTriangle } from 'react-icons/fi';
import siteMessages from '../../pages/root/siteMessages';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  id?: string;
  name: string;
  label: string;
  value: boolean | null;
  onChange: (value: boolean) => void;
  error?: any;
}

const YesNoButton = (props: Props) => {
  const intl = useIntl();
  const yesNoOptions = [
    {
      value: 'true',
      label: intl.formatMessage({ ...siteMessages.YES })
    },
    {
      value: 'false',
      label: intl.formatMessage({ ...siteMessages.NO })
    }
  ];

  useEffect(() => {
    const eles = document.querySelectorAll("input[class='btn-check']");
    eles.forEach((e) => e.setAttribute('tabindex', '-1'));
  }, []);

  return (
    <Form.Group controlId={props.name} className="btn-yes-no" id={props.id}>
      <p className="label">{props.label}</p>
      <div className="ms-auto">
        <ToggleButtonGroup
          type="radio"
          name={props.name}
          value={props.value?.toString()}
          className={props.error && 'btn-error'}
        >
          {yesNoOptions.map((o) => (
            <ToggleButton
              key={o.value}
              value={o.value}
              onClick={() => props.onChange(o.value === 'true')}
            >
              {o.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        {props.error && (
          <div className="feedback">
            <FiAlertTriangle className="mb-1 me-1" />
            {props.error}
          </div>
        )}
      </div>
    </Form.Group>
  );
};

export default YesNoButton;
